import { render, staticRenderFns } from "./HorseWithoutAct.vue?vue&type=template&id=81201bc8&"
import script from "./HorseWithoutAct.vue?vue&type=script&lang=js&"
export * from "./HorseWithoutAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports